<template>
  <div>
    <page-title
      :title="$t('scenes.referral.program.terms.conditions.title')"
      title-tag="h1"
      :back-button="{ url: breadcrumbs[0].link, hiddenAfterSizes: 'sm' }"
      :bordered="true"
    />
    <div class="referral-terms-and-conditions-page my-20 my-md-30 my-lg-40 px-20 px-sm-30">
      <breadcrumb :breadcrumbs="breadcrumbs" />
      <div class="referral-terms-and-conditions new-container mx-auto">
        <p class="referral-terms-and-conditions-content" v-html="content" />
      </div>
    </div>
  </div>
</template>

<script>
  import Breadcrumb from '~/components/partner-with-us/breadcrumb'
  import PageTitle from '~/components/shared/page-title.vue'

  export default {
    name: 'referral-terms-and-conditions',

    components: {
      Breadcrumb,
      PageTitle,
    },

    data() {
      return {
        breadcrumbs: [
          {
            title: this.$t('components.main.navigation.referral-page'),
            link: '/referral',
          },
          {
            title: this.$t('scenes.referral.program.terms.conditions.title'),
          },
        ],
        content: [],
      }
    },

    async fetch() {
      try {
        const responseData = await this.$store.dispatch('fetch_contents_page', 'referral-program-terms-conditions')

        if (responseData) {
          this.content = responseData.content
        }
      } catch (err) {}
    },
  }
</script>

<style lang="scss" scoped>
  .referral-terms-and-conditions-page {
    .referral-terms-and-conditions {
      &-title {
        color: #4a4a4a;
        font-size: 27px;
        font-weight: 600;
        letter-spacing: -0.5px;
        line-height: 32px;

        @media only screen and (max-width: 575px) {
          font-size: 19px;
          line-height: 22px;
        }
      }
      &-content {
        color: #8a8a8a;
        font-size: 15px;
        letter-spacing: 0;
        line-height: 21px;
      }
    }
  }
</style>
